import { useMemo } from 'react';

import {
  useIsLongFormContentArticlePublisherEnabled,
  useIsLongFormContentFormattingOptionsEnabled,
} from '../../featureChecks';
import { UseMainUIFeatureSettings } from '../../types';

export const useLongFormContentSettings: UseMainUIFeatureSettings<'longFormContent'> = (options) => {
  const longFormContentOverrides = options?.overrides?.longFormContent;
  const formattingOptions = useIsLongFormContentFormattingOptionsEnabled();
  const articlePublisher = useIsLongFormContentArticlePublisherEnabled();

  return useMemo(
    () => ({
      formattingOptions,
      articlePublisher,
      ...longFormContentOverrides,
    }),
    [articlePublisher, formattingOptions, longFormContentOverrides]
  );
};
